import * as React from 'react'
import UploaderV2 from '../../../../uploader_v2_app/uploader'
import LnkSplitter from '../../../../shared/lnk_splitter'
import ItemTags from './item_tags'
import ItemName from './item_name'
import LocationName from './location_name'
import { CloneLnk, RemoveLnk } from './action_links'
import CollapseExpandControl from '../../../../shared/collapse_expand'
import TagBadge from '../../../../shared/tags/badge'

type ElementRowProps = {
  item: any
  onChange: any
  clickSelect: any
  clickClone: any
  clickRemove: any
  uploaderProps: any
  expandStateAction: any
  showAdditions?: boolean
  showImages?: boolean
  visibleColumns?: string[]
  onAdditionChange?: any
}

export default function ElementRow(props: ElementRowProps) {
  const {
    item,
    onChange,
    clickSelect,
    clickClone,
    clickRemove,
    uploaderProps,
    expandStateAction,
    showAdditions,
    showImages,
    visibleColumns,
    onAdditionChange,
  } = props
  const {
    locationName,
    isCopy,
    name,
    sku,
    dimensions,
    note,
    minAmount,
    maxAmount,
    tags,
    matchedTags,
    tagIDs,
    photoUncuttedThumb,
    availableAdditions,
    additionIds,
  } = item
  const { I18n } = window as any

  const isColumnVisible = (column: string) => {
    if (!visibleColumns || visibleColumns.length === 0) return true
    return visibleColumns.includes(column)
  }

  const actions = []
  if (!item.isLocation) {
    actions.push(<CloneLnk key="clone-lnk" onClick={clickClone} />)
  }
  if (actions.length > 0) {
    actions.push(<LnkSplitter key="lnk-plitter" />)
  }
  actions.push(<RemoveLnk key="remove-lnk" onClick={clickRemove} />)

  return (
    <tr>
      <td className="name-cell">
        <div className="d-flex justify-content-between">
          <div>
            {tagIDs.length > 0 && <CollapseExpandControl {...expandStateAction} />}
            <LocationName name={locationName} />
            <ItemName isCopy={isCopy} name={name} onChange={onChange} />
            <ItemTags tags={matchedTags} />
          </div>
          {showImages && photoUncuttedThumb && (
            <div>
              <img className="float-right" src={photoUncuttedThumb} alt="" style={{ maxHeight: '150px' }} />
            </div>
          )}
        </div>
      </td>
      <td>{sku || ''}</td>
      <td className="min-amount-cell">
        <input type="text" value={minAmount} onChange={onChange} name="minAmount" className="form-control" />
      </td>
      <td className="max-amount-cell">
        <input type="text" value={maxAmount} onChange={onChange} name="maxAmount" className="form-control" />
      </td>
      {isColumnVisible('dimensions') && (
        <td>{dimensions}</td>
      )}
      {isColumnVisible('pdf') && (
        <td className="uploader-cell">
          <UploaderV2 {...uploaderProps} />
        </td>
      )}
      {isColumnVisible('note') && (
        <td>
          <input value={note} onChange={onChange} name="note" className="w-100 form-control" />
        </td>
      )}
      {showAdditions && isColumnVisible('additions') && (
        <td className="additions-cell">
          {availableAdditions && availableAdditions.length > 0 ? (
            <select
              value={additionIds && additionIds.length > 0 ? additionIds[0] : ''}
              onChange={onAdditionChange}
              className="form-control"
            >
              <option value="">-</option>
              {availableAdditions.map((addition) => (
                <option key={addition.value} value={addition.value}>
                  {addition.label}
                </option>
              ))}
            </select>
          ) : null}
        </td>
      )}
      {isColumnVisible('tags') && (
        <td className="tags-cell">
          <a onClick={clickSelect}>{I18n.t('application.actions.select')}</a>
          <div>
            {tags.map((tag) => (
              <TagBadge key={`tag-${tag.value}`} type={tag.type} name={tag.label} />
            ))}
          </div>
        </td>
      )}
      <td>{actions}</td>
    </tr>
  )
}
